import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import Footer from "./components/Footer";
import LGPD from "./components/LGPD";
import Menu from "./components/Menu";

import { About, Content, Header, Success } from "./pages";

function App() {
  return (
    <div className="App">
      <LGPD />
      <Menu />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <About />
                <Content />
                {/* <FormPage /> */}
              </>
            }
          ></Route>
          <Route path="/sucesso" element={<Success />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
